<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Liste des structures</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="data" :options="options">
          <div slot="action" slot-scope="props">
            <span v-if="canAccess(rules.MANAGE_STRUCTURES)">
                <i class="fa fa-pencil mr-2 text-primary clickable" @click="editStructure( props.row.id)"></i>
            </span>
            <span v-if="canAccess(rules.MANAGE_STRUCTURES)">
              <i class="fa fa-trash clickable text-danger" @click.prevent="destroy(props.row)"></i>
            </span>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer">
        <b-button v-if="canAccess(rules.MANAGE_STRUCTURES)" type="button" @click="addStructure" class="pull-right" size="md" variant="primary">
          <i class="fa fa-plus"></i> Ajouter une structure
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";
  import {rules, hasRule} from '@/utils/rulesHelper';

  export default {
    name: "List",
    data() {
      return {
        rules: rules,
        columns: ['libelle', 'libelle_technique', 'code_postal', 'ville', 'ordre', 'action'],
        data: [],
        options: {
          headings: {
            'libelle': 'Libellé',
            'libelle_technique': 'Libellé technique',
            'code_postal': 'Code postal',
            'ville': 'Ville',
            'ordre': 'Ordre',
          },
          filterable: ['nom'],
          perPage: 10,
          perPageValues: [10, 25, 50],
          texts: {
            filterPlaceholder: "Libellé"
          },
        }
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.all();
    },
    methods: {
      canAccess(rule) {
        return hasRule(rule)
      },
      all() {
        this.$axios
          .get("/administration/structures")
          .then(response => this.data = response.data.structures)
          .catch(() => {
            this.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Un probléme est survenue, merci de contacter l\'administrateur',
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
      destroy(id) {
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: "Voulez-vous vraiment supprimer cette structure ?",
            type: 'warning',
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor: "#ff1744",
            confirmButtonText: 'Annuler',
            cancelButtonText: 'Supprimer',
          })
          .then((result) => {
            if (!result.value) {
              this.$store.commit('IS_LOADING', true)
              this.$axios
                .post("/administration/structures/delete/" + id)
                .then(() => {
                  this.$store.commit('IS_LOADING', false)
                  this.$swal({
                    position: 'top',
                    type: 'success',
                    title: 'Suppression avec succès',
                    text: "La structure a bien été supprimée",
                    showConfirmButton: false,
                    timer: 4000
                  })
                  this.all()
                })
                .catch(() => {
                  self.$store.commit('IS_LOADING', false)
                  self.$swal({
                    position: 'top',
                    type: 'warning',
                    title: 'Attention !!',
                    text: 'Un problème est survenu, merci de contacter un administrateur',
                    showConfirmButton: false,
                    timer: 5000
                  })
                })
            }
          })

      },
      addStructure() {
        this.$router.push({path: '/administration/structures/add'})
      },
      editStructure(id) {
        this.$router.push({path: '/administration/structures/edit/' + id})
      }
    }
  }
</script>
